module.exports = __webpack_public_path__ + "img/IIToolkitColorPicker.30092768.jpg";